import TrainsTypeaheadController from './controllers/trains-typeahead-controller';

import TrainRoutes from './train-routes';

const MODULE_NAME = 'App.Trains';
const module = angular
    .module(MODULE_NAME, [
        'app',
    ])
    .controller('TrainsTypeaheadController', TrainsTypeaheadController)
    .config(TrainRoutes);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/train/train-module.js